export const AppConfig = {
    baseUrl: process.env.REACT_APP_HOST_URL + "/",
}

export default AppConfig